import {
  GetAccountDocument,
  ProfileInput,
  useUpdateCurrentUserMutation,
} from "gql/generated.graphql";
import { useState } from "react";
import { useBackendErrorMessage } from "dash-ui";

interface UseConfirmSsoNameOptions {
  onConfirmed?: () => void;
}

/**
 * Saves the name an SSO user confirmed after signing in (DSH-939).
 *
 * Refetches the account rather than trusting cache normalisation: the gate that
 * opens this form reads `account.profile.lastName`, so a stale read reopens the
 * form the moment it closes.
 */
export function useConfirmSsoName({
  onConfirmed,
}: UseConfirmSsoNameOptions = {}) {
  const translate = useBackendErrorMessage();
  const [error, setError] = useState("");

  const [updateCurrentUser, { loading }] = useUpdateCurrentUserMutation({
    refetchQueries: [GetAccountDocument],
    awaitRefetchQueries: true,
  });

  const confirm = (profileInput: ProfileInput) => {
    setError("");

    updateCurrentUser({
      variables: { profileInput },
      onCompleted: () => onConfirmed?.(),
      onError: (mutationError) => setError(translate(mutationError)),
    });
  };

  return { confirm, saving: loading, error };
}
